import Divider from '@mui/material/Divider';
import React from 'react';

/**
 * Menu section break — 4px vertical margin.
 *
 * MUI MenuItem ships `.MuiMenuItem-root + .MuiDivider-root { margin-block: 8px }`.
 * That sibling rule is injected after Divider `sx` and wins a specificity tie, so we
 * need `&&&` (0,3,0) to reliably beat it.
 */
export function QMenuDivider(): React.ReactElement {
  return <Divider sx={{ '&&&': { my: 0.5 } }} />;
}

// MenuList skips a child when `child.type.muiSkipListHighlight` is set (MUI Divider
// does this). Wrappers must re-expose it or a leading divider steals activeItemIndex
// and arrow keys never reach a row.
QMenuDivider.muiSkipListHighlight = true;
